import { render } from "./TranscriptionItemizedSummary.vue?vue&type=template&id=ae7a6764&scoped=true"
import script from "./TranscriptionItemizedSummary.vue?vue&type=script&lang=js"
export * from "./TranscriptionItemizedSummary.vue?vue&type=script&lang=js"

import "./TranscriptionItemizedSummary.vue?vue&type=style&index=0&id=ae7a6764&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ae7a6764"

export default script